import axios from "axios";
import { reqInstance, resolveUrl } from "./Common";

export const createAutoGeneratedUserReq = async (nickname) => {
  try {
    const resp = await reqInstance.post("user/create/auto-generated", { nickname });
    return resp.data;
  } catch (err) {
    throw err;
  }
};

export const signOutReq = async () => {
  try {
    const resp = await reqInstance.post("user/signout");
    return resp.data;
  } catch (err) {
    throw err;
  }
};
